module.exports = __webpack_public_path__ + "img/makeup.3b1d4f7d.jpg";